const types = ['Arguments', 'Function', 'Array', 'Object', 'String', 'Number', 'Date',
    'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'];
const fns = {};
types.forEach(v => {
    fns[`is${v}`] = obj => {
        return Object.prototype.toString.call(obj) === `[object ${v}]`
    }
});
fns.isJson = obj => {
    if (fns.isString(obj)) {
        try {
            const o = JSON.parse(obj);
            return fns.isObject(o) || fns.isArray(o)
        } catch (err) {
            return false
        }
    }
    return false
};

export default {
    ...fns
}
